import { render, staticRenderFns } from "./StaffLoanAdvanceReportPrint.vue?vue&type=template&id=6c2fb0c7&scoped=true&"
import script from "./StaffLoanAdvanceReportPrint.vue?vue&type=script&lang=js&"
export * from "./StaffLoanAdvanceReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./StaffLoanAdvanceReportPrint.vue?vue&type=style&index=0&id=6c2fb0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2fb0c7",
  null
  
)

export default component.exports